<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M15.3995 7.39947C15.7314 7.06753 16.2687 7.06753 16.6006 7.39947C16.9325 7.73142 16.9326 8.26872 16.6006 8.60064L13.2012 12.0001L16.6006 15.3995C16.9325 15.7314 16.9326 16.2687 16.6006 16.6006C16.2687 16.9326 15.7314 16.9325 15.3995 16.6006L12.0001 13.2012L8.60064 16.6006C8.26872 16.9326 7.73142 16.9325 7.39947 16.6006C7.06753 16.2687 7.06753 15.7314 7.39947 15.3995L10.7989 12.0001L7.39947 8.60064C7.06753 8.2687 7.06753 7.73142 7.39947 7.39947C7.73142 7.06753 8.2687 7.06753 8.60064 7.39947L12.0001 10.7989L15.3995 7.39947Z"
      fill="white" />
  </svg>
</template>
